query ListUsageOutliers($limit: Int, $nextToken: String) {
  page: StreamToolsListUsageOutliers(limit: $limit, nextToken: $nextToken) {
    items {
      accountId
      email
      suspendedAt
      estimatedCents
      ytQuotaPctOfMonthlyBudget
    }
    nextToken
    orderMode
    rankedAt
  }
}
